import React,{Component} from 'react';
import $ from 'jquery';
import {Link,browserHistory} from 'react-router';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class ChangeNumber extends Component {
	constructor(props){
		super(props);
		this.state={
			mobile: '',
			err_mobile:'',
			err_mobile_status: false,
		};
		this.handleSubmit=this.handleSubmit.bind(this);
		this.mobileChange=this.mobileChange.bind(this);
	}

	handleSubmit(e){

		e.preventDefault();
      	var data1 = {from: 'mobile_web', uid: localStorage.user_id , token: localStorage.token, mobile: this.refs.mobile.value}
      	var data2= JSON.stringify(data1);
      	localStorage.setItem('mobile_number',this.refs.mobile.value);
		$.ajax({
			method: 'POST',
			url: baseUrl+'changeMobile',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				// console.log(data);
					if(data.status ==="error"){
						this.setState({
							err_mobile_status:true,
							err_mobile: data.msg,
						});
					}
					else{
						this.setState({
							err_mobile_status: false,
							err_mobile: '',
						});
					}
				if(data.status==="success"){
					browserHistory.push('/verify_otp');
				}

			}.bind(this),
			error: function(err){
				// console.log(err);
			}
		});
	}
	mobileChange(e){
		this.setState({
			err_mobile_status: false,
		})
	}

	render(){
		document.title="Change Number | AquaDeals";
		return(
			<div className="mob_deals mob_numberchng_page">
				<section className="tot_pag">
					<div className="page_hdr">
						<div className="container">
							<h5><Link to={"/profile"}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>Change Mobile Number</h5>
                			<a href="/" className="home_newicon"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home"/></a>
						</div>		
					</div>
				</section>   
				<div className="clr">&nbsp;</div>
				<section className="pag_cntnt">
					<div className="col-md-6 col-md-offset-3">
						<div className="">
							<div className="enquire_form signup_blk proced_blk">
								<div className="clr">&nbsp;</div>
								<div className="clr">&nbsp;</div>
								<div className="newlogin_logo"><img src={baseAssets+'icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
								<form className="mtrl_elmnts" onSubmit={this.handleSubmit.bind(this)}>
								      <div className="col-md-12" style={{marginLeft:'40px',marginRight:'40px'}}>
								            <div className="group">      
									          <img src={baseAssets+'icons/web_icons/cell_dl.png'} alt="" style={{position:'absolute',top:'11px',left:'0px'}} />
									          <input type="text" placeholder="Enter Mobile" ref="mobile" required maxLength={10} onChange={this.mobileChange}/>
									          <span className="highlight"></span>
									          <span className="bar"></span>
									          <span style={{fontSize: '12px',color:'red'}}>{this.state.err_mobile_status ? this.state.err_mobile : ''}</span>
									        </div>
									        <div className="clr">&nbsp;</div>
									        <div><button action="submit" className="btn mob_changenumber_btn">Verify <i className="glyphicon glyphicon-menu-right"></i></button></div>
								        
								      </div>
								</form>
								<div className="clr"></div>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
}
}





/** WEBPACK FOOTER **
 ** ./src/components/Auth/change_number.js
 **/